import React, {Component} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert, FormSelect } from 'react-bootstrap';
import UserService from "./services/auth.service";
import RoleService from "./services/role.service";
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { IoIosArrowBack } from "react-icons/io";
import TopAndSideBar from './TopAndSideBar';
import { NewHeader } from './AuxiliaryFunctions';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const NewUserAuth = () => {
  const { user: currentUser } = useSelector((state) => state.auth) 
  // Admin role is id = 3
  return (
    (currentUser.roles.includes(3))?(<NewUser />):<Container><div style={{textAlign:"center",justifyContent:'center',display:'flex'}}>{currentUser.username} does not have privileges to see this page.</div></Container>
    
  )
}

class NewUser extends Component {  

  constructor(props) {
    super(props);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangeUserFirstname = this.onChangeUserFirstname.bind(this);
    this.onChangeUserLastname = this.onChangeUserLastname.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.saveUser = this.saveUser.bind(this);
    this.handleValidations = this.handleValidations.bind(this);
    this.onChangeEmployeeNumber = this.onChangeEmployeeNumber.bind(this);
    this.onChangeUserType = this.onChangeUserType.bind(this);

    this.state = {
      id: null,
      employeenumber: "",
      userfirstname: "",
      userlastname: "",
      username: "",
      email: "",
      password: "password",
      roles: [2],
      showerror: false,
      errmessage:'',   
      showsuccess: false,
      succmessage: '',
      roles: [],
      usertype: [] // user role

    };
  }
  
  componentDidMount() {
    RoleService.getAll()
    .then((response) => {
      this.setState({errmessage:''});
      this.setState({showerror:false});
      //this.setState({succmessage:response.data.message});
      //this.setState({showsuccess:true}); 
      this.setState({roles:response.data});
      console.log(response.data);
    })
    .catch((err) => {
      console.error(err);
      this.setState({errmessage:err.response?err.response.data.message:err.message});       
      this.setState({showerror:true});
      this.setState({succmessage:''});
      this.setState({showsuccess:false}); 
    })
  }

  goToUserList() {
    window.location.assign('/admin-users');
  }

  handleValidations() {
    if (this.state.userfirstname.length==0 || this.state.userlastname.length==0 || this.state.password.length==0 || this.state.usertype.length==0) {
      this.setState({errmessage:'Firstname, lastname and user type can not be empty.'})
      this.setState({showerror:true})
      return;
    }
    if (this.state.email) {
      if (!/\S+@\S+\.\S+/.test(this.state.email)) {
        this.setState({errmessage:'Email is invalid.'})
        this.setState({showerror:true})
        return;
      }
    }
    this.saveUser();
  } 

  onChangeEmployeeNumber(e) {
    this.setState({
      employeenumber: e.target.value
    });
  }

  onChangeUserFirstname(e) {
    this.setState({
      userfirstname: e.target.value
    });
  }

  onChangeUserLastname(e) {
    this.setState({
      userlastname: e.target.value
    });
  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value
    });
  }

  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    });
  }

  onChangeUserType(e) {
    this.setState({
      usertype: [e.target.value]
    });    
  }

  saveUser() {
    var pw = Math.random().toString(36).substr(2, 8);
    UserService.register(this.state.userfirstname, this.state.userlastname, this.state.email, pw, pw, this.state.usertype)        
      .then(response => {
        this.setState({
          password: pw,
          submitted: true
        });
        this.setState({errmessage:''})
        this.setState({showerror:false})
        this.setState({succmessage:response.data.message})
        this.setState({showsuccess:true})            
      })
      .catch(e => {
        console.log(e);
        this.setState({errmessage:e.response?e.response.data.message:e.message})       
        this.setState({showerror:true})
        this.setState({succmessage:''})
        this.setState({showsuccess:false})          
      });
  }

  render() {
    return (
      <>
      <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
        <TopAndSideBar />
        <NewHeader headerTitle={"New User"}/>

        <div style={{padding:"0 8vw",}}>
        <Row className='mb-2'>          
          <Col className='col-md-3'>
            <FormLabel className='mb-2'>User Type:</FormLabel>       
              <select onChange={this.onChangeUserType} className="form-control" id="usertype" name="usertype">
                <ListOfRoles roles={this.state.roles}/>       
              </select>
          </Col> 

          <Col className='col-md-3'>
            <FormLabel className='mb-2'>Employee Number:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="employeenumber" id="employeenumber" onChange={this.onChangeEmployeeNumber}></FormControl>
          </Col>          
          <Col className='col-md-3'>
            <FormLabel className='mb-2'>User Firstname:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="userfirstname" id="userfirstname" onChange={this.onChangeUserFirstname}></FormControl>
          </Col>
          <Col className='col-md-3'>
            <FormLabel className='mb-2'>User Lastname:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="userlastname" id="userlastname" onChange={this.onChangeUserLastname}></FormControl>
          </Col>
          <Col className='col-md-3'>
            <FormLabel className='mb-2'>Username:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="username" id="username" onChange={this.onChangeUsername}></FormControl>
          </Col>

          <Col className='col-md-3'>
            <FormLabel className='mb-2'>Email:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="email" id="email" onChange={this.onChangeEmail}></FormControl>
          </Col>          

        </Row>
        <Row>
            
        </Row>
        <Row>
            <Col className='mt-4'>                                
                <FormLabel className='mb-2'>Password</FormLabel>       
                <FormControl style={{maxWidth:"300px"}} value={this.state.password} type="text" name="password" id="password" disabled onChange={this.onChangePassword}></FormControl>
                <div className='mb-2'>Password will be generated when user is saved. Please, share this information with the user. You can always reset the password if needed.</div>       
            </Col>  
        </Row>
        <hr/>
        <Row className='mb-2'>
          <Col className='col-md-3'>
            <Button className='m-2' id='saveUser' onClick={this.handleValidations}>Save User</Button>            
            <Button className='m-2' id='backToUsersList' onClick={this.goToUserList}><IoIosArrowBack/></Button>            
          </Col>
        </Row>  
        {this.state.showerror && (
          <Alert variant="danger" onClose={() => this.setState({showerror:false})} dismissible>
            <Alert.Heading>Error</Alert.Heading>
            <p>{this.state.errmessage}</p>
          </Alert>      
        )}
        {this.state.showsuccess && (
          <Alert variant="success" onClose={() => this.setState({showsuccess:false})} dismissible>
            <Alert.Heading>Done</Alert.Heading>
            <p>{this.state.succmessage}</p>
          </Alert>      
        )}     
        </div>
      </div>
      </>
    )      
  }
}

const ListOfRoles = (props) => {
  if (!props.roles) {
    return 
  }
  const rows = props.roles.map((row, index) => {
    return (  
      <option key={index} value={row.id}>        
        {row.rolename}
      </option>
    )
  })  
  return (      
    <>        
    <option disabled selected>
      {"Select"}
    </option>
    {rows}
    </>
  )
}

export default NewUserAuth;